module.exports = __webpack_public_path__ + "static/media/ruhtinas-blue-bg-gold-200x89.35d827f2.png";